import React from 'react';
import { Polygon, Popup } from 'react-leaflet';

export interface ClusterBoundary {
    _id: string;
    name: string;
    boundary?: { type: string; coordinates: number[][][] };
    totalShops?: number;
    status?: string;
}

interface ClusterBoundaryLayerProps {
    clusters: ClusterBoundary[];
    selectedId?: string | null;
    onSelect?: (clusterId: string) => void;
}

const COLORS = ['#22c55e', '#3b82f6', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899'];

const ClusterBoundaryLayer: React.FC<ClusterBoundaryLayerProps> = ({
    clusters,
    selectedId = null,
    onSelect
}) => {
    return (
        <>
            {clusters.map((cluster, idx) => {
                const boundary = cluster.boundary;
                if (!boundary || !boundary.coordinates) return null;

                const color = COLORS[idx % COLORS.length];

                const positions: [number, number][] = boundary.coordinates[0]?.map(
                    (coord: number[]) => [coord[1], coord[0]] as [number, number]
                ) || [];

                if (positions.length < 3) return null;

                return (
                    <Polygon
                        key={cluster._id}
                        positions={positions}
                        pathOptions={{
                            color,
                            fillColor: color,
                            fillOpacity: selectedId === cluster._id ? 0.25 : 0.15,
                            weight: selectedId === cluster._id ? 3 : 2,
                            opacity: 0.9
                        }}
                        eventHandlers={{
                            click: () => onSelect?.(cluster._id)
                        }}
                    >
                        <Popup>
                            <div className="text-sm">
                                <strong>{cluster.name}</strong>
                                <br />
                                {cluster.totalShops ?? 0} shops · {cluster.status || 'active'}
                            </div>
                        </Popup>
                    </Polygon>
                );
            })}
        </>
    );
};

export default ClusterBoundaryLayer;
